import React from 'react';
import IntegrationsLogsTable from '../../integrationLayout/integrationsLogsTable';

const Status = ({ crm, syncDirections }) => {
  return <IntegrationsLogsTable crm={crm} syncDirections={syncDirections} />;
};

export default Status;
